export const RetryBox = ({ onRetry, text = "Beiträge konnten nicht geladen werden." }) => (
  <div className="text-center py-10 space-y-3" data-testid="load-error">
    <p className="text-sm text-slate-500">{text}</p>
    <button onClick={onRetry} data-testid="load-retry-btn" className="px-5 h-10 rounded-full bg-white border border-pink-200 text-sm font-semibold text-rose-600 hover:bg-rose-50">Erneut versuchen</button>
  </div>
);
